import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-382b1b86")

_pushScopeId("data-v-382b1b86")
const _hoisted_1 = { class: "pop-up" }
const _hoisted_2 = { class: "bg-hoverbox" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "play-btn" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "14",
    height: "17",
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M0.616211 2.42438V15.547C0.616211 16.6952 1.89542 17.3783 2.84545 16.7368L13.3484 9.65017C14.2581 9.03619 14.2061 7.67746 13.2521 7.13532L2.75812 1.17341C1.80193 0.630142 0.616211 1.3227 0.616211 2.42438Z",
      fill: "#fff"
    })
  ])
], -1)
const _hoisted_5 = { class: "content-holder" }
const _hoisted_6 = {
  key: 0,
  class: "speakers"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_8 = { class: "speaker-hldr" }
const _hoisted_9 = { class: "name-title" }
const _hoisted_10 = { class: "button-holder" }
const _hoisted_11 = {
  key: 0,
  class: "button button-moment"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("svg", {
  width: "14",
  height: "17",
  viewBox: "0 0 14 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    class: "fill-cta",
    d: "M0.616211 2.42438V15.547C0.616211 16.6952 1.89542 17.3783 2.84545 16.7368L13.3484 9.65017C14.2581 9.03619 14.2061 7.67746 13.2521 7.13532L2.75812 1.17341C1.80193 0.630142 0.616211 1.3227 0.616211 2.42438Z"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "button button-fv" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "14",
    height: "17",
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      class: "fill-fv",
      d: "M0.616211 2.42438V15.547C0.616211 16.6952 1.89542 17.3783 2.84545 16.7368L13.3484 9.65017C14.2581 9.03619 14.2061 7.67746 13.2521 7.13532L2.75812 1.17341C1.80193 0.630142 0.616211 1.3227 0.616211 2.42438Z"
    })
  ]),
  /*#__PURE__*/_createVNode("span", {
    class: "fv-btn-text",
    innerHTML: `Full Video`
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("video", {
          class: "video",
          ref: "video",
          crossorigin: "true",
          poster: _ctx.webinar.trailer.video_urls.poster_url,
          loop: "",
          muted: ""
        }, null, 8, ["poster"]),
        _hoisted_4
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("h3", {
          class: "pop-title",
          innerHTML: _ctx.webinar.title
        }, null, 8, ["innerHTML"]),
        (_ctx.hasSpeakers)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("div", _hoisted_8, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.webinar.speakers, (speaker, i) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "speaker-tile",
                    key: i
                  }, [
                    (speaker.poster_url)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: speaker.poster_url
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_9, [
                      _createVNode("span", {
                        class: "name",
                        innerHTML: speaker.name
                      }, null, 8, ["innerHTML"]),
                      (speaker.title)
                        ? (_openBlock(), _createBlock("span", {
                            key: 0,
                            innerHTML: `,${speaker.title}`
                          }, null, 8, ["innerHTML"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_10, [
          (_ctx.hasMoments)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _hoisted_12,
                _createVNode("span", {
                  class: "moment-btn-text",
                  innerHTML: `Moments (${_ctx.webinar.moments.length})`
                }, null, 8, ["innerHTML"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_13
        ])
      ])
    ])
  ]))
})